import React from "react";

const LocateIcon = ({ size = "40", fill = "#BEBEBE" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1025_562)">
        <path
          d="M19.88 33.5C20.02 33.7 20.245 33.825 20.49 33.825H20.5C20.74 33.825 20.965 33.71 21.11 33.515L25.13 27.955C25.375 27.62 25.295 27.15 24.96 26.91C24.625 26.67 24.155 26.745 23.915 27.08L20.52 31.775L13.36 21.29C13.125 20.95 12.66 20.86 12.32 21.095C11.98 21.33 11.89 21.795 12.125 22.135L19.885 33.505L19.88 33.5Z"
          fill={fill}
        />
        <path
          d="M11.5 9.625H13.25C16.345 9.625 17.66 9.815 20.275 11.955C22.095 13.445 23.605 14.575 24.855 15.375H20.745C20.33 15.375 19.995 15.71 19.995 16.125C19.995 16.54 20.33 16.875 20.745 16.875H28.265C28.35 16.885 28.43 16.89 28.51 16.89C28.56 16.89 28.61 16.885 28.655 16.875H29.93C31.485 16.875 32.75 18.14 32.75 19.695V21.875H30.47C30.22 19.765 28.425 18.125 26.25 18.125C24.075 18.125 22.28 19.765 22.03 21.875H17.25C16.835 21.875 16.5 22.21 16.5 22.625C16.5 23.04 16.835 23.375 17.25 23.375H22.125C22.575 25.235 24.255 26.625 26.25 26.625C28.245 26.625 29.925 25.235 30.375 23.375H33.5C33.915 23.375 34.25 23.04 34.25 22.625V19.695C34.25 17.315 32.31 15.375 29.93 15.375H28.325C27.46 15.26 25.53 14.32 21.225 10.795C18.27 8.38 16.525 8.125 13.25 8.125H12.94C14.825 5.755 17.665 4.375 20.75 4.375C26.025 4.375 30.41 8.495 30.73 13.75C30.755 14.15 31.085 14.455 31.48 14.455C31.495 14.455 31.51 14.455 31.525 14.455C31.94 14.43 32.255 14.075 32.23 13.66C31.86 7.61 26.815 2.875 20.75 2.875C16.7 2.875 13.03 4.94 10.92 8.4C10.815 8.53 10.75 8.69 10.75 8.875C10.75 9.29 11.085 9.625 11.5 9.625ZM26.25 25.125C24.735 25.125 23.5 23.89 23.5 22.375C23.5 20.86 24.735 19.625 26.25 19.625C27.765 19.625 29 20.86 29 22.375C29 23.89 27.765 25.125 26.25 25.125Z"
          fill={fill}
        />
        <path
          d="M8.5 16.875H15C15.415 16.875 15.75 16.54 15.75 16.125C15.75 15.71 15.415 15.375 15 15.375H8.5C8.085 15.375 7.75 15.71 7.75 16.125C7.75 16.54 8.085 16.875 8.5 16.875Z"
          fill={fill}
        />
        <path
          d="M9.25 13.125H12.25C12.665 13.125 13 12.79 13 12.375C13 11.96 12.665 11.625 12.25 11.625H9.25C8.835 11.625 8.5 11.96 8.5 12.375C8.5 12.79 8.835 13.125 9.25 13.125Z"
          fill={fill}
        />
        <path
          d="M5.5 16.875C5.915 16.875 6.25 16.54 6.25 16.125C6.25 15.71 5.915 15.375 5.5 15.375H3.5C3.085 15.375 2.75 15.71 2.75 16.125C2.75 16.54 3.085 16.875 3.5 16.875H5.5Z"
          fill={fill}
        />
        <path
          d="M4.25 19.625C4.25 20.04 4.585 20.375 5 20.375H7.5C7.915 20.375 8.25 20.04 8.25 19.625C8.25 19.21 7.915 18.875 7.5 18.875H5C4.585 18.875 4.25 19.21 4.25 19.625Z"
          fill={fill}
        />
        <path
          d="M14.75 19.625C14.75 19.21 14.415 18.875 14 18.875H10.5C10.085 18.875 9.75 19.21 9.75 19.625C9.75 20.04 10.085 20.375 10.5 20.375H14C14.415 20.375 14.75 20.04 14.75 19.625Z"
          fill={fill}
        />
        <path
          d="M26.25 23.875C27.0784 23.875 27.75 23.2034 27.75 22.375C27.75 21.5466 27.0784 20.875 26.25 20.875C25.4216 20.875 24.75 21.5466 24.75 22.375C24.75 23.2034 25.4216 23.875 26.25 23.875Z"
          fill={fill}
        />
        <path
          d="M37.02 35.835L30.02 29.085C29.88 28.95 29.695 28.875 29.5 28.875H26.115C25.7 28.875 25.365 29.21 25.365 29.625C25.365 30.04 25.7 30.375 26.115 30.375H29.2L34.645 35.625H5.955L11.79 30.375H14.81C15.225 30.375 15.56 30.04 15.56 29.625C15.56 29.21 15.225 28.875 14.81 28.875H11.5C11.315 28.875 11.135 28.945 11 29.065L3.5 35.815C3.27 36.025 3.19 36.35 3.3 36.64C3.41 36.93 3.69 37.12 4 37.12H36.5C36.805 37.12 37.08 36.935 37.195 36.65C37.31 36.365 37.24 36.04 37.02 35.83V35.835Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1025_562">
          <rect width={size} height={size} fill={fill} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LocateIcon;
